import { z } from "zod";
import { uuidLoose } from "./uuid.js";
/**
 * Wire-format DTOs for the P17 Cash on Delivery (COD) workflow.
 *
 * Lifecycle:
 *   1. Customer checks out with `payment_mode='cod'` (gated on
 *      `companies.cod_enabled`) → order `status='placed'`,
 *      `payment_processor='cod'`, no invoice.
 *   2. Admin dispatches: POST /v1/admin/orders/:id/dispatch with
 *      `{driver_staff_id}` → `status='out_for_delivery'`, sets
 *      `dispatched_at` + `driver_staff_id` (FK staff_members).
 *   3a. Cash collected on the doorstep: POST .../cod-collected →
 *       `status='paid'`, sets `cod_collected_at` +
 *       `cod_marked_paid_by_staff_id`, inserts `payments` row
 *       (method='cod' processor='cod'), issues invoice via
 *       `InvoiceService.issueForOrder({paymentTerms:'cod'})` with
 *       `due_date=null` + `status='paid'` as a VAT receipt.
 *   3b. Buyer refuses: POST .../cod-refused → `status='cancelled'`,
 *       sets `cancellation_reason='cod_refused'`.
 *
 * Response interfaces (not Zod schemas) because they are server-emitted only
 * and never client-parsed at runtime — same convention as `invoice.ts` /
 * `order.ts` response DTOs.
 */
/**
 * Body for `POST /v1/admin/orders/:id/dispatch`.
 *
 * `driver_staff_id` uses `uuidLoose` per L102 — the admin SPA may send seeded
 * version-0 UUIDs from P02-T12 fixtures during dev/staging; Zod v4's strict
 * `.uuid()` would reject them despite Postgres accepting the column value.
 */
export const DispatchOrderBodySchema = z.object({
    driver_staff_id: uuidLoose,
});
